module.exports = __webpack_public_path__ + "img/LogisticRegression.33244ab2.png";